import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { Chip } from '../Chip/Chip.es.js';
import { Input } from '../Input/Input.es.js';
import { Box } from '../../primitives/Box/Box.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var ChipWrapper = styled(Box).withConfig({
  componentId: "b1y3ep-0"
})(["display:grid;grid-gap:xs;grid-auto-flow:column;overflow-x:scroll;margin-left:2px;-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}"]);
var defaultChip = forwardRef(function (_a, ref) {
  var _b = _a,
      value = _b.value,
      props = __objRest(_b, ["value"]);

  return (
    /* @__PURE__ */
    React.createElement(Chip, __spreadValues({
      ref: ref
    }, props), value)
  );
});
var ChipInput = forwardRef(function (_c, ref) {
  var _d = _c,
      shape = _d.shape,
      _d$size = _d.size,
      size = _d$size === void 0 ? "md" : _d$size,
      variant = _d.variant,
      _d$limitChipValues = _d.limitChipValues,
      limitChipValues = _d$limitChipValues === void 0 ? 0 : _d$limitChipValues,
      isDisabled = _d.isDisabled,
      isReadOnlyProp = _d.isReadOnly,
      id = _d.id,
      type = _d.type,
      autoComplete = _d.autoComplete,
      placeholder = _d.placeholder,
      _d$wrapperRef = _d.wrapperRef,
      wrapperRefProp = _d$wrapperRef === void 0 ? null : _d$wrapperRef,
      _d$inputRef = _d.inputRef,
      inputRef = _d$inputRef === void 0 ? null : _d$inputRef,
      _d$splitSymbols = _d.splitSymbols,
      splitSymbols = _d$splitSymbols === void 0 ? ", " : _d$splitSymbols,
      _d$regExpForInputText = _d.regExpForInputText,
      regExpForInputText = _d$regExpForInputText === void 0 ? "^[a-zA-Z ]*$" : _d$regExpForInputText,
      getResult = _d.getResult,
      values = _d.values,
      onChange = _d.onChange,
      onKeyDown = _d.onKeyDown,
      onFocus = _d.onFocus,
      onBlur = _d.onBlur,
      onAdd = _d.onAdd,
      onRemove = _d.onRemove,
      addChipOnBlur = _d.addChipOnBlur,
      _d$value = _d.value,
      value = _d$value === void 0 ? "" : _d$value,
      _d$getItemsLabel = _d.getItemsLabel,
      getItemsLabel = _d$getItemsLabel === void 0 ? function (value2) {
    return value2;
  } : _d$getItemsLabel,
      _d$chipComponent = _d.chipComponent,
      ChipComponent = _d$chipComponent === void 0 ? defaultChip : _d$chipComponent,
      addonLeft = _d.addonLeft,
      isMultiline = _d.isMultiline,
      props = __objRest(_d, ["shape", "size", "variant", "limitChipValues", "isDisabled", "isReadOnly", "id", "type", "autoComplete", "placeholder", "wrapperRef", "inputRef", "splitSymbols", "regExpForInputText", "getResult", "values", "onChange", "onKeyDown", "onFocus", "onBlur", "onAdd", "onRemove", "addChipOnBlur", "value", "getItemsLabel", "chipComponent", "addonLeft", "isMultiline"]);

  var _useState = useState(value),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  var _useState2 = useState([]),
      chipArrayValues = _useState2[0],
      setChipArrayValues = _useState2[1];

  var _useState3 = useState(isReadOnlyProp),
      isReadOnly = _useState3[0],
      setReadOnly = _useState3[1];

  var createRegExpFromSplitSymbols = useCallback(function (_ref) {
    var isForStringMatch = _ref.isForStringMatch;
    var symbolsArray = Array.from(splitSymbols);
    var pattern = "[" + symbolsArray.join("|") + "]";
    return isForStringMatch ? pattern : new RegExp(pattern);
  }, [splitSymbols]);
  useEffect(function () {
    if (inputValue.match(createRegExpFromSplitSymbols({
      isForStringMatch: true
    })) && inputValue.length > 1) {
      var replace = inputValue.replace(createRegExpFromSplitSymbols({
        isForStringMatch: false
      }), "");
      var newValues = [].concat(_toConsumableArray(chipArrayValues), [replace.trim()]);
      setChipArrayValues(newValues);
      setInputValue("");

      if (onAdd) {
        onAdd(newValues);
      }
    }
  }, [chipArrayValues, createRegExpFromSplitSymbols, inputValue, onAdd]);
  useEffect(function () {
    if (getResult) {
      getResult(chipArrayValues);
    }
  }, [chipArrayValues, getResult]);
  useEffect(function () {
    if (values) {
      setChipArrayValues(values);
      setInputValue("");
    }
  }, [values]);
  useEffect(function () {
    if (limitChipValues === 0) {
      return;
    }

    setReadOnly((chipArrayValues == null ? void 0 : chipArrayValues.length) >= limitChipValues);
  }, [chipArrayValues, limitChipValues]);

  var handleInputChange = function handleInputChange(event) {
    var value2 = event.target.value;
    var regExp = new RegExp(regExpForInputText);
    var isFirstCharIsOneOfSplitSymbols = Array.from(splitSymbols).includes(value2[0]);

    if (regExp.test(value2) || !isFirstCharIsOneOfSplitSymbols) {
      setInputValue(value2);
    }

    if (onChange) {
      onChange(event);
    }
  };

  var handleDeleteChip = function handleDeleteChip(chipComponentIndex) {
    if (chipComponentIndex === void 0) {
      chipComponentIndex = -1;
    }

    chipArrayValues.splice(chipComponentIndex, 1);

    var newValues = _toConsumableArray(chipArrayValues);

    setChipArrayValues(newValues);

    if (onRemove) {
      onRemove(newValues);
    }
  };

  var handleAddChip = function handleAddChip() {
    var newValues = [].concat(_toConsumableArray(chipArrayValues), [inputValue]);
    setChipArrayValues(newValues);
    setInputValue("");

    if (onAdd) {
      onAdd(newValues);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    if ((event.key === "Backspace" || event.key === "Delete") && inputValue === "") {
      handleDeleteChip();
    }

    var regExp = new RegExp(regExpForInputText);

    if (event.key === "Enter" && inputValue !== "" && regExp.test(inputValue)) {
      event.preventDefault();
      handleAddChip();
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleFocus = function handleFocus(event) {
    if (onFocus) {
      onFocus(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    var regExp = new RegExp(regExpForInputText);

    if (addChipOnBlur && inputValue !== "" && regExp.test(inputValue)) {
      handleAddChip();
    }

    if (onBlur) {
      onBlur(event);
    }
  };

  return (
    /* @__PURE__ */
    React.createElement(Input, __spreadProps(__spreadValues({
      ref: ref,
      inputRef: inputRef,
      wrapperRef: wrapperRefProp,
      id: id,
      placeholder: placeholder,
      type: type,
      size: size,
      shape: shape,
      variant: variant,
      isDisabled: isDisabled,
      isReadOnly: isReadOnly,
      autoComplete: autoComplete,
      onChange: handleInputChange,
      onKeyDown: handleKeyDown,
      onFocus: handleFocus,
      onBlur: handleBlur,
      value: inputValue,
      isMultiline: isMultiline
    }, props), {
      addonLeft: [addonLeft].concat([!!(chipArrayValues == null ? void 0 : chipArrayValues.length) && (isMultiline ?
      /* @__PURE__ */
      React.createElement(React.Fragment, null, chipArrayValues.map(function (value2, index) {
        return (
          /* @__PURE__ */
          React.createElement(ChipComponent, {
            key: index + "-" + value2,
            size: size,
            onDismiss: function onDismiss() {
              return handleDeleteChip(index);
            },
            value: getItemsLabel(value2),
            isDisabled: isDisabled,
            isMultiline: isMultiline
          })
        );
      })) :
      /* @__PURE__ */
      React.createElement(ChipWrapper, null, chipArrayValues.map(function (value2, index) {
        return (
          /* @__PURE__ */
          React.createElement(ChipComponent, {
            key: index + "-" + value2,
            size: size,
            onDismiss: function onDismiss() {
              return handleDeleteChip(index);
            },
            value: getItemsLabel(value2),
            isDisabled: isDisabled,
            sx: {
              marginLeft: "xxs",
              p: "0px 6px 0px 10px"
            }
          })
        );
      })))])
    }))
  );
});
ChipInput.displayName = "ChipInput";
export { ChipInput };